export default function getValidFeatures(eventId: string, resp: any): any[] | undefined {
  const features = resp?.data?.tcTrackDetails?.features;

  if (!Array.isArray(features) || features.length === 0) {
    console.warn(`无效的台风轨迹数据: eventId=${eventId}`);
    return undefined;
  }

  return features;
}
